import { Dispatch, IAppState } from 'shared/common/state';
import { IApplicationContext } from 'shared/types/applicationContext';
import { EEmptyStateActionType, IEmptyStateAction } from 'shared/types/emptyState';

import { applyEmptyStateJsonQuery } from './applyEmptyStateJsonQuery';

/**
 * Выполняет действие из блока пустой выдачи.
 *
 * `changeFilters` приходит, когда ручка не смогла собрать теги для сброса: применять нечего,
 * поэтому просто открываем модалку фильтров. Остальные действия несут готовый jsonQuery.
 */
export function applyEmptyStateAction(action: IEmptyStateAction) {
  return async (dispatch: Dispatch, getState: () => IAppState, context: IApplicationContext) => {
    const { logger, microfrontendsAPI, microfrontendsRegistry } = context;

    if (action.type === EEmptyStateActionType.ChangeFilters) {
      if (!microfrontendsAPI || !microfrontendsRegistry.microfrontend('desktop-filters-micro-frontend')) {
        return;
      }

      try {
        await microfrontendsAPI.getDesktopFiltersMicrofrontendApi().openAllFiltersModal();
      } catch (error) {
        logger.error(error, { degradation: 'Открытие фильтров из блока пустой выдачи' });
      }

      return;
    }

    if (!action.jsonQuery) {
      return;
    }

    await applyEmptyStateJsonQuery(action.jsonQuery)(dispatch, getState, context);
  };
}
